// extracted by mini-css-extract-plugin
module.exports = {"call_blocking_module":"styles_call_blocking_module__1fB3_"};